export const ACTUALIZAR_SOLICITUD = "ACTUALIZAR_SOLICITUD";
export const AGREGAR_SOLICITUD = "AGREGAR_SOLICITUD";
export const MODIFICAR_FILTROS_ESTADOS_SOLICITUD = "MODIFICAR_FILTROS_ESTADOS_SOLICITUD"; 
export const MODIFICAR_FILTROS_RANGO_SOLICITUD = "MODIFICAR_FILTROS_RANGO_SOLICITUD";
export const INICIAR_FILTROS_SOLICITUD = "INICIAR_FILTROS_SOLICITUD"; 